// extracted by mini-css-extract-plugin
module.exports = {"cardheight":"ProductsDisplay_cardheight__1V1Cg"};